import './AboutPageContent.css';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowRight, Plus
} from 'lucide-react';
import { Factory, Heart, Plane, Truck, Building, ShoppingBag, HardHat, Package } from 'lucide-react';
import Button from '../components/Button';
import manufacturingBg from '../assets/Industries/Manufacturing.webp';
import healthcareBg from '../assets/Industries/Healthcare.webp';
import airportsBg from '../assets/Industries/Airports.webp';
import logisticsBg from '../assets/Industries/Logistics.webp';
import realEstateBg from '../assets/Industries/Real Estate.webp';
import constructionBg from '../assets/Industries/Construction.webp';
import warehousingBg from '../assets/Industries/Warehousing.webp';
import SocialCard from '../components/ui/social-card';
import LogoCloudSwap from '../components/ui/logo-clouds';
import aboutusImg from '../assets/About_Us_Images/About  Us Image1.webp';
import aboutusImg2 from '../assets/About_Us_Images/About  Us Image2.webp';
import aboutusImg3 from '../assets/About_Us_Images/About  Us Image3.webp';
import smilaiImg from '../assets/smilai_background.webp';
import factoraiImg from '../assets/factorai_background.webp';
import securaiImg from '../assets/securai_preview.webp';
import nallasivanImage from '../assets/Nallasivan Thirugnanam.webp';
import harikrishnanImage from '../assets/Harikrishnan Profile.webp';
import sritharImage from '../assets/Srithar.webp';
import sanjaiImage from '../assets/Sanjai.webp';
import aiFirstIcon from '../assets/AI-First Technology Solutions_icons/AI-First Innovation.webp';
import enterpriseSystemsIcon from '../assets/AI-First Technology Solutions_icons/Enterprise Systems.webp';
import cloudAutomationIcon from '../assets/AI-First Technology Solutions_icons/Cloud & Automation.webp';
import industrialIotIcon from '../assets/AI-First Technology Solutions_icons/Industrial IoT & Automation.webp';
import customProductIcon from '../assets/About_Us_Images/Custom Product Development.webp';
import innovationIcon from '../assets/Company Culture_icons/Innovation-Driven.webp';
import qualityIcon from '../assets/Company Culture_icons/Quality-Focused.webp';
import customerIcon from '../assets/Company Culture_icons/Customer-Centric.webp';

import phoneIcon from '../assets/About_Us_Images/phone.webp';
import websiteIcon from '../assets/About_Us_Images/website.webp';
import googleMapsIcon from '../assets/About_Us_Images/google-maps.webp';
import gmailIcon from '../assets/About_Us_Images/gmail.webp';
import linkedinIconPng from '../assets/About_Us_Images/linkedin.webp';
import instagramIconPng from '../assets/About_Us_Images/instagram.webp';
import facebookIconPng from '../assets/About_Us_Images/facebook.webp';
import whatsappIcon from '../assets/About_Us_Images/whatsapp.webp';

interface AboutProps {
  preview?: boolean;
}

export const AboutPageContent: React.FC<AboutProps> = ({ preview = false }) => {
  if (preview) {
    return (
      <section className="section about-section" id="about">
        <div className="about-mesh-bg" aria-hidden="true" />
        <div className="about-glow-orb-1" aria-hidden="true" />
        <div className="about-glow-orb-2" aria-hidden="true" />

        <div className="container relative-z">
          <div className="about-intro-block reveal-on-scroll">
            <h2 className="about-headline">
              Your Trusted <span className="text-gradient">Technology Partner</span>
            </h2>
            <p className="about-lead-text">
              Vivify Soft Tech is an <span className="highlight-text">AI-first technology company</span> combining <span className="highlight-text">deep software engineering</span> with advanced machine intelligence to deliver robust solutions. We architect for <span className="highlight-text">scale, speed, and safety</span> across industrial IoT, cloud, and SaaS contexts to help organizations conquer market transitions.
            </p>
            <div className="about-preview-cta" style={{ marginTop: '2rem' }}>
              <Link to="/about">
                <Button variant="primary" size="md" icon={<ArrowRight size={16} />}>
                  Learn More About Us
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <main className="about-page" style={{ overflowX: 'hidden' }}>

      {/* SEO Meta */}
      {(() => { document.title = 'About Vivify Soft Tech | AI, Software, Cloud & Automation Company'; return null; })()}

      {/* ════════════ HERO SECTION ════════════ */}
      <section className="about-hero" aria-label="About Vivify Soft Tech">
        <img
          src="/About_Herobanner.webp"
          alt=""
          fetchPriority="high"
          className="about-hero-bg-img"
          title="Vivify Soft Tech" />
        <div className="about-hero-bg-overlay" />
        <div className="about-hero-bg">
          <div className="about-hero-grid" />
          <div className="about-hero-orb-1" />
          <div className="about-hero-orb-2" />
        </div>

        <div className="container about-hero-inner">
          <div className="about-hero-content">
            <h1 className="about-hero-h1">
              About <span className="accent">Vivify Soft Tech</span>
            </h1>

            <p className="about-hero-meta">
              An innovative technology company that helps businesses accelerate digital transformation through AI-powered software, enterprise applications, cloud technologies, industrial automation, and custom digital solutions.
            </p>

            <div className="about-hero-actions">
              <Link to="/services" className="about-hero-secondary-btn">
                Explore Services
              </Link>
              <Link to="/products" className="about-hero-secondary-btn">
                View Products
              </Link>
              <Link to="/solutions" className="about-hero-secondary-btn">
                Our Solutions
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="about-overview-section" aria-label="Company Introduction">
        <div className="container">
          <div className="overview-layout">
            <div className="overview-content-side">
              <p className="overview-content-desc" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#fff' }}>
                Vivify Soft Tech is a technology and software solutions company based in Chennai, Tamil Nadu, India.
                <br /><br />
                The company provides technology solutions across artificial intelligence, enterprise software, ERP, business automation, industrial software, Industrial IoT, custom product development, cloud technologies and IT services.
                <br /><br />
                Vivify Soft Tech works with businesses to develop software solutions, automate business and industrial processes, modernize technology environments and support digital transformation initiatives.
              </p>
            </div>
            <div className="overview-image-side">
              <img loading="lazy" decoding="async" src={aboutusImg} alt="Vivify Soft Tech Overview" width="1059" height="706" className="overview-img overview-img-main" title="Vivify Soft Tech" />
            </div>
          </div>
        </div>
      </section>

      {/* ════════════ 2. COMPANY FACTS ════════════ */}
      <section className="about-facts-section" aria-label="Company Facts" style={{ padding: '0 0 4rem 0', background: 'rgba(255,255,255,0.02)' }}>
        <div className="container">
          <div className="about-section-header" style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h2 className="about-section-title">Company Facts</h2>
          </div>
          <div style={{ maxWidth: '900px', margin: '0 auto', background: '#0f172a', padding: '1rem 3rem', borderRadius: '16px', border: '1px solid rgba(139, 92, 246, 0.2)' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <tbody>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7', width: '30%' }}>Company</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>Vivify Soft Tech</td>
                </tr>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Brand</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>Vivify Soft Tech</td>
                </tr>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Location</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>Chennai, Tamil Nadu, India</td>
                </tr>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Website</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>vivifysoft.com</td>
                </tr>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Business Type</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>Technology & Software Solutions Company</td>
                </tr>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Core Focus</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>AI, Enterprise Software, ERP & Automation</td>
                </tr>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Industrial Focus</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>Industrial Software, Industrial IoT & Automation</td>
                </tr>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Services</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>Enterprise Software, AI Solutions, Custom Product Development, Cloud & IT Services</td>
                </tr>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Products</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>SecurAI, FactorAI and SmilAI</td>
                </tr>
                <tr>
                  <th style={{ padding: '0.4rem 0', fontWeight: '600', color: '#a855f7' }}>Industries</th>
                  <td style={{ padding: '0.4rem 0', color: '#cbd5e1' }}>Manufacturing, Healthcare, Airports, Logistics, Real Estate, Retail, Construction and Warehousing</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ════════════ 3. WHAT VIVIFY SOFT TECH DOES ════════════ */}
      <section style={{ padding: '4rem 0' }} aria-label="What We Do">
        <div className="container">
          <div className="about-section-header" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 className="about-section-title">
              What Vivify Soft Tech <span className="text-gradient-purple">Does</span>
            </h2>
          </div>

          <div className="what-we-do-grid">
            <div className="expertise-card panel-card panel-hover" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', borderRadius: '16px' }}>
              <div className="career-header" style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <span className="career-inline-icon"><img loading="lazy" src={aiFirstIcon} alt="AI" width="35" height="35" style={{ width: '35px', height: '35px', objectFit: 'contain' }} /></span>
                <h3 className="career-card-title" style={{ margin: 0, fontSize: '1.1rem' }}>Artificial Intelligence</h3>
              </div>
              <p className="career-card-desc" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                Vivify Soft Tech develops AI-powered solutions designed for business, operational and industry-specific applications.
              </p>
            </div>

            <div className="expertise-card panel-card panel-hover" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', borderRadius: '16px' }}>
              <div className="career-header" style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <span className="career-inline-icon"><img loading="lazy" src={enterpriseSystemsIcon} alt="Enterprise" width="30" height="30" style={{ width: '30px', height: '30px', objectFit: 'contain' }} /></span>
                <h3 className="career-card-title" style={{ margin: 0, fontSize: '1.1rem' }}>Enterprise Software</h3>
              </div>
              <p className="career-card-desc" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                The company develops enterprise software solutions including business applications, ERP, CRM, HRMS and workflow-oriented systems.
              </p>
            </div>

            <div className="expertise-card panel-card panel-hover" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', borderRadius: '16px' }}>
              <div className="career-header" style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <span className="career-inline-icon"><img loading="lazy" src={industrialIotIcon} alt="Industrial" width="30" height="30" style={{ width: '30px', height: '30px', objectFit: 'contain' }} /></span>
                <h3 className="career-card-title" style={{ margin: 0, fontSize: '1.1rem' }}>Industrial Automation</h3>
              </div>
              <p className="career-card-desc" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                Vivify Soft Tech provides industrial software, automation and Industrial IoT solutions for connected and data-driven industrial operations.
              </p>
            </div>

            <div className="expertise-card panel-card panel-hover" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', borderRadius: '16px' }}>
              <div className="career-header" style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <span className="career-inline-icon"><img loading="lazy" src={customProductIcon} alt="Custom Product" width="30" height="30" style={{ width: '30px', height: '30px', objectFit: 'contain' }} /></span>
                <h3 className="career-card-title" style={{ margin: 0, fontSize: '1.1rem' }}>Custom Product Development</h3>
              </div>
              <p className="career-card-desc" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                The company develops custom web applications, mobile applications, SaaS platforms and enterprise applications.
              </p>
            </div>

            <div className="expertise-card panel-card panel-hover" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', borderRadius: '16px' }}>
              <div className="career-header" style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <span className="career-inline-icon"><img loading="lazy" src={cloudAutomationIcon} alt="Cloud" width="30" height="30" style={{ width: '30px', height: '30px', objectFit: 'contain' }} /></span>
                <h3 className="career-card-title" style={{ margin: 0, fontSize: '1.1rem' }}>Cloud & IT Services</h3>
              </div>
              <p className="career-card-desc" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                Cloud migration, managed services, DevOps, CI/CD and security-related technology services support organizations modernizing their IT environments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ════════════ 4. SOLUTIONS ════════════ */}
      <section style={{ padding: '3rem 0', background: 'rgba(255,255,255,0.02)' }} aria-label="Solutions">
        <div className="container solutions-main-grid">

          {/* Left Side: Title, Desc, Image */}
          <div className="text-center lg:text-left">
            <h2 className="about-section-title text-center lg:text-left mb-4 !text-4xl lg:!text-[3.2rem] !font-bold lg:!font-extrabold leading-tight">
              Our <span className="text-gradient-purple">Solutions</span>
            </h2>
            <p className="mb-10 text-slate-400 text-lg leading-relaxed">
              Vivify Soft Tech's technology solutions cover a wide range of specialized areas to drive your business forward.
            </p>
            <img loading="lazy" src={aboutusImg2} alt="Solutions Overview" style={{ width: '90%', maxWidth: '520px', borderRadius: '16px', objectFit: 'cover', height: '220px', border: '1px solid rgba(255,255,255,0.1)' }} />
          </div>

          {/* Right Side: 8 Feature Cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>

            <Link to="/solutions/enterprise-digital-transformation" style={{ textDecoration: 'none', background: 'rgba(15, 23, 42, 0.6)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', padding: '0.65rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', transition: 'all 0.3s ease' }}>
              <div style={{ flexShrink: 0, width: '28px' }}><img src={enterpriseSystemsIcon} alt="Enterprise" style={{ width: '100%' }} /></div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}><span style={{ color: '#a855f7' }}>Enterprise</span> Digital Transformation</h4>
              </div>
            </Link>

            <Link to="/solutions/ai-business-solutions" style={{ textDecoration: 'none', background: 'rgba(15, 23, 42, 0.6)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', padding: '0.65rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', transition: 'all 0.3s ease' }}>
              <div style={{ flexShrink: 0, width: '28px' }}><img src={aiFirstIcon} alt="AI" style={{ width: '100%' }} /></div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}><span style={{ color: '#a855f7' }}>AI</span> Business Solutions</h4>
              </div>
            </Link>

            <Link to="/solutions/intelligent-automation-systems" style={{ textDecoration: 'none', background: 'rgba(15, 23, 42, 0.6)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', padding: '0.65rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', transition: 'all 0.3s ease' }}>
              <div style={{ flexShrink: 0, width: '28px' }}><img src={innovationIcon} alt="Automation" style={{ width: '100%' }} /></div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}><span style={{ color: '#a855f7' }}>Intelligent</span> Automation Systems</h4>
              </div>
            </Link>

            <Link to="/solutions/business-process-automation" style={{ textDecoration: 'none', background: 'rgba(15, 23, 42, 0.6)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', padding: '0.65rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', transition: 'all 0.3s ease' }}>
              <div style={{ flexShrink: 0, width: '28px' }}><img src={customerIcon} alt="Process" style={{ width: '100%' }} /></div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}><span style={{ color: '#a855f7' }}>Business</span> Process Automation</h4>
              </div>
            </Link>

            <Link to="/solutions/industrial-iot-solutions" style={{ textDecoration: 'none', background: 'rgba(15, 23, 42, 0.6)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', padding: '0.65rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', transition: 'all 0.3s ease' }}>
              <div style={{ flexShrink: 0, width: '28px' }}><img src={industrialIotIcon} alt="IoT" style={{ width: '100%' }} /></div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}><span style={{ color: '#a855f7' }}>Industrial</span> IoT Solutions</h4>
              </div>
            </Link>

            <Link to="/solutions/enterprise-workflow-platforms" style={{ textDecoration: 'none', background: 'rgba(15, 23, 42, 0.6)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', padding: '0.65rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', transition: 'all 0.3s ease' }}>
              <div style={{ flexShrink: 0, width: '28px' }}><img src={qualityIcon} alt="Factory" style={{ width: '100%' }} /></div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}><span style={{ color: '#a855f7' }}>Enterprise</span> Workflow Platforms</h4>
              </div>
            </Link>

            <Link to="/solutions/scalable-enterprise-applications" style={{ textDecoration: 'none', background: 'rgba(15, 23, 42, 0.6)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', padding: '0.65rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', transition: 'all 0.3s ease' }}>
              <div style={{ flexShrink: 0, width: '28px' }}><img src={enterpriseSystemsIcon} alt="Software" style={{ width: '100%' }} /></div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}><span style={{ color: '#a855f7' }}>Scalable</span> Enterprise Applications</h4>
              </div>
            </Link>

            <Link to="/solutions/cloud-based-systems" style={{ textDecoration: 'none', background: 'rgba(15, 23, 42, 0.6)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', padding: '0.65rem 1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', transition: 'all 0.3s ease' }}>
              <div style={{ flexShrink: 0, width: '28px' }}><img src={cloudAutomationIcon} alt="Cloud" style={{ width: '100%' }} /></div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#fff', fontWeight: '600' }}><span style={{ color: '#a855f7' }}>Cloud-Based</span> Systems</h4>
              </div>
            </Link>

          </div>
        </div>
      </section>

      {/* ════════════ 5. PRODUCTS ════════════ */}
      <section className="about-products-section" aria-label="Products">
        <div className="container">
          <div className="about-section-header" style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h2 className="about-section-title">Products</h2>
          </div>

          <div className="about-circular-products-grid">
            {([
              {
                name: 'SecurAI',
                desc: 'SecurAI is a Vivify Soft Tech product focused on intelligent safety, security and compliance applications.',
                label: 'Explore SecurAI',
                img: securaiImg,
                href: '/products/securai',
              },
              {
                name: 'FactorAI',
                desc: 'FactorAI is a Vivify Soft Tech product.',
                label: 'Explore FactorAI',
                img: factoraiImg,
                href: '/products/factorai',
              },
              {
                name: 'SmilAI',
                desc: 'SmilAI is a Vivify Soft Tech product.',
                label: 'Explore SmilAI',
                img: smilaiImg,
                href: '/products/smilai',
              },
            ] as const).map((p) => (
              <Link key={p.name} to={p.href} className="about-circular-product-card" aria-label={`Explore ${p.name}`}>
                {/* Background image */}
                <img loading="lazy" src={p.img} alt={`${p.name} Preview`} className="about-circular-product-bg-img" title="Vivify Soft Tech" />
                {/* Dark overlay */}
                <div className="about-circular-product-dark-overlay" />
                {/* Content */}
                <div className="about-circular-product-content">
                  <h3 className="about-circular-product-name">{p.name}</h3>
                  <p className="about-circular-product-desc">{p.desc}</p>
                  <span className="about-circular-product-link-badge">
                    {p.label} <ArrowRight size={12} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════ 6. INDUSTRIES WE SERVE ════════════ */}
      <AboutIndustriesSection />

      {/* ════════════ 7. OUR VISIONARIES ════════════ */}
      <section className="about-team-section" aria-label="Our Visionaries">
        <div className="container">
          <div className="visionaries-header">
            <h2 className="visionaries-title">Leadership & Key Team Members at Vivify Soft Tech</h2>
            <p className="visionaries-subtitle">
              Vivify Soft Tech's leadership and technology professionals contribute expertise across enterprise technology, software solutions, operations, AI, industrial automation, business solutions and digital transformation.
            </p>
          </div>
          <TeamCardsGrid />
        </div>
      </section>

      {/* ════════════ 8. OUR TECHNOLOGY EXPERTISE ════════════ */}
      <LogoCloudSwap className="py-20 sm:py-28" />

      {/* ════════════ 9. WHY BUSINESSES WORK WITH US ════════════ */}
      <section className="about-why-section" aria-label="Why Businesses Work With Vivify Soft Tech">
        <div className="container">
          <div className="about-why-layout">

            {/* Left: Content */}
            <div className="about-why-content">
              <h2 className="about-why-title">
                Why Businesses Work With <span className="text-gradient-purple">Vivify Soft Tech</span>
              </h2>
              <p className="about-why-lead">
                Vivify Soft Tech combines software engineering, artificial intelligence, enterprise technology and industrial automation capabilities to develop technology solutions aligned with business and operational requirements.
              </p>
              <p className="about-why-lead">
                The company's work spans enterprise applications, automation, industrial technologies, AI-powered solutions, cloud systems and custom digital products.
              </p>
            </div>

            {/* Right: Image */}
            <div className="about-why-image-side">
              <img
                loading="lazy"
                src={aboutusImg3}
                alt="Why Vivify Soft Tech"
                width="1059"
                height="706"
                className="about-why-img"
                title="Vivify Soft Tech"
              />
            </div>

          </div>
        </div>
      </section>

      {/* ════════════ 10. COMPANY PRESENCE ════════════ */}
      <section style={{ padding: '0', background: 'rgba(255,255,255,0.02)' }} aria-label="Company Presence & Official Profiles">
        <div className="container">
          <h2 className="about-section-title" style={{ textAlign: 'center' }}>Company Presence & Official Profiles</h2>
          <div style={{ marginTop: '2.5rem', display: 'flex', justifyContent: 'center' }}>
            <SocialCard 
              title="Follow Us"
              socialLinks={[
                { href: "https://www.linkedin.com/company/vivify-soft-tech/", icon: <img src={linkedinIconPng} alt="LinkedIn" className="cg-icon-img" />, className: "box1" },
                { href: "https://www.instagram.com/vivify_soft_tech/", icon: <img src={instagramIconPng} alt="Instagram" className="cg-icon-img" />, className: "box2", delay: "0.2s" },
                { href: "https://www.facebook.com/profile.php?id=61589751765485", icon: <img src={facebookIconPng} alt="Facebook" className="cg-icon-img" />, className: "box3", delay: "0.4s" },
              ]}
            />
          </div>
        </div>
      </section>

      {/* ════════════ 11. CONTACT ════════════ */}
      <section className="about-cta-section" aria-label="Contact Vivify Soft Tech" style={{ paddingTop: '0' }}>
        <div className="about-cta-glow" />
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="contact-grid-layout">
            
            <div className="contact-grid-content">
              <h2 style={{ fontSize: '3rem', fontWeight: 700, marginBottom: '1.5rem', lineHeight: 1.1 }}>
                Contact Us
              </h2>
              <p style={{ fontSize: '1.25rem', color: '#94a3b8', lineHeight: 1.6, marginBottom: '2rem' }}>
                Connect with us across multiple platforms to streamline our communication and start building something great together.
              </p>
              <Link to="/contact" className="about-hero-primary-btn" style={{ display: 'inline-flex' }}>
                Get In Touch <ArrowRight size={16} />
              </Link>
            </div>

            <div className="contact-grid-visual">
              {/* Column 1 (Outer - 2 boxes) */}
              <div className="cg-col cg-col-outer">
                <a href="https://wa.me/917305730528" target="_blank" rel="noopener noreferrer" className="cg-box cg-hoverable" aria-label="WhatsApp"><img src={whatsappIcon} alt="WhatsApp" className="cg-icon-img" /></a>
                <a href="tel:+917305730528" className="cg-box cg-hoverable" aria-label="Phone"><img src={phoneIcon} alt="Phone" className="cg-icon-img" /></a>
              </div>
              
              {/* Column 2 (Mid - 3 boxes) */}
              <div className="cg-col cg-col-mid">
                <div className="cg-box cg-empty" />
                <a href="https://www.vivifysoft.com" target="_blank" rel="noopener noreferrer" className="cg-box cg-hoverable" aria-label="Website"><img src={websiteIcon} alt="Website" className="cg-icon-img" /></a>
                <div className="cg-box cg-empty" />
              </div>
              
              {/* Column 3 (Center - 4 boxes) */}
              <div className="cg-col cg-col-center">
                <div className="cg-box cg-empty" />
                <a
                  href="https://www.google.com/maps/place/Vivify+Soft+Tech/@13.0958613,80.17367,17z/data=!3m1!4b1!4m6!3m5!1s0x3a5263fd873ad447:0x5966f5106b73fc96!8m2!3d13.0958613!4d80.17367!16s%2Fg%2F11w2_k9f7b"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cg-box cg-hoverable"
                  aria-label="View Vivify Soft Tech Location on Google Maps"
                >
                  <img src={googleMapsIcon} alt="Address" className="cg-icon-img" />
                </a>
                <a href="mailto:reach@vivifysoft.com" className="cg-box cg-hoverable" aria-label="Email"><img src={gmailIcon} alt="Email" className="cg-icon-img" /></a>
                <div className="cg-box cg-empty" />
              </div>
              
              {/* Column 4 (Mid - 3 boxes) */}
              <div className="cg-col cg-col-mid">
                <a href="https://www.linkedin.com/company/vivify-soft-tech/" target="_blank" rel="noopener noreferrer" className="cg-box cg-hoverable" aria-label="LinkedIn"><img src={linkedinIconPng} alt="LinkedIn" className="cg-icon-img" /></a>
                <a href="https://www.instagram.com/vivify_soft_tech/" target="_blank" rel="noopener noreferrer" className="cg-box cg-hoverable" aria-label="Instagram"><img src={instagramIconPng} alt="Instagram" className="cg-icon-img" /></a>
                <div className="cg-box cg-empty" />
              </div>
              
              {/* Column 5 (Outer - 2 boxes) */}
              <div className="cg-col cg-col-outer">
                <a href="https://www.facebook.com/profile.php?id=61589751765485" target="_blank" rel="noopener noreferrer" className="cg-box cg-hoverable" aria-label="Facebook"><img src={facebookIconPng} alt="Facebook" className="cg-icon-img" /></a>
                <div className="cg-box cg-empty" />
              </div>
            </div>

          </div>
        </div>
      </section>



    </main>
  );
};

const aboutIndustriesList = [
  { name: 'Manufacturing',  tagline: 'IoT Monitoring & Smart Automation',          icon: <Factory size={28} />,     image: manufacturingBg, link: '/industries' },
  { name: 'Healthcare',     tagline: 'AI Diagnostics & Patient Care',               icon: <Heart size={28} />,       image: healthcareBg,    link: '/industries' },
  { name: 'Airports',       tagline: 'Computer Vision & Smart Security',            icon: <Plane size={28} />,       image: airportsBg,      link: '/industries' },
  { name: 'Logistics',      tagline: 'Warehouse Automation & Fleet Management',     icon: <Truck size={28} />,       image: logisticsBg,     link: '/industries' },
  { name: 'Real Estate',    tagline: 'Property Management & Digital Contracts',     icon: <Building size={28} />,    image: realEstateBg,    link: '/industries' },
  { name: 'Retail',         tagline: 'Inventory Management & POS Automation',       icon: <ShoppingBag size={28} />, image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=400&q=80', link: '/industries' },
  { name: 'Construction',   tagline: 'Construction Safety & Equipment Monitoring',  icon: <HardHat size={28} />,     image: constructionBg,  link: '/industries' },
  { name: 'Warehousing',    tagline: 'Warehouse Automation & Inventory Management', icon: <Package size={28} />,     image: warehousingBg,   link: '/industries' },
];

const AboutIndustriesSection: React.FC = () => {
  // Duplicate list for seamless infinite loop
  const allItems = [...aboutIndustriesList, ...aboutIndustriesList];
  return (
    <section className="about-ind-section" aria-label="Industries We Serve">
      <div className="container">
        <div className="section-header centered">
          <h2 className="section-title">Industries We Serve</h2>
          <p>Vivify Soft Tech provides technology solutions for industries including:</p>
        </div>
      </div>

      {/* Full-width marquee — no scroll arrows */}
      <div className="about-ind-marquee-outer">
        <div className="about-ind-marquee-track">
          {allItems.map((ind, idx) => (
            <Link
              key={idx}
              to={ind.link}
              className="about-ind-circle-card"
              aria-label={ind.name}
              style={{
                backgroundImage: `linear-gradient(rgba(10,14,26,0.55), rgba(10,14,26,0.82)), url("${ind.image}")`,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem', width: '100%' }}>
                <div className="about-ind-circle-icon">{ind.icon}</div>
                <h3 className="about-ind-circle-name">{ind.name}</h3>
              </div>
              <p className="about-ind-circle-tagline">{ind.tagline}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};



const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const LinkedinIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z" />
  </svg>
);

const TwitterIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.953 4.57a10 10 0 002.856-3.51 9.86 9.86 0 01-2.836.856 4.88 4.88 0 00-8.52 4.452c-4.044-.2-7.612-2.14-10.01-5.1a4.93 4.93 0 00-.666 2.457 4.88 4.88 0 002.17 4.066 4.87 4.87 0 01-2.21-.616v.06a4.88 4.88 0 003.91 4.78 4.88 4.88 0 01-2.2.085 4.89 4.89 0 004.56 3.392 9.8 9.8 0 01-6.08 2.1 9.87 9.87 0 01-1.171-.069 13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
  </svg>
);

// ════════════ TEAM CARDS GRID COMPONENT ════════════
interface TeamMember {
  id: number;
  name: string;
  title: string;
  image: string;
  width: number;
  height: number;
  bio: string;
  social: {
    facebook?: string;
    linkedin?: string;
    twitter?: string;
  };
}

const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: 'T. Nallasivan',
    title: 'Founder Director',
    image: nallasivanImage,
    width: 1105,
    height: 1424,
    bio: 'T. Nallasivan is the Founder of Vivify Group and a technocrat with 26+ years of experience in civil aviation, security screening, industrial automation and delivering mission-critical infrastructure solutions.',
    social: {
      linkedin: 'https://www.linkedin.com/in/t-nallasivan-279899b',
    },
  },
  {
    id: 2,
    name: 'Harikrishnan Anandan',
    title: 'Head of Operations',
    image: harikrishnanImage,
    width: 1254,
    height: 1254,
    bio: 'Harikrishnan Anandan With 25+ years in operational and execution leadership, driving organizational scale through process management and innovative software solutions that automate workflows to accelerate growth.',
    social: {
      linkedin: 'https://www.linkedin.com/in/harikrishnan-anandan-2ab0431',
    },
  },
  {
    id: 3,
    name: 'Sritharan Jayaraman',
    title: 'CTO',
    image: sritharImage,
    width: 1109,
    height: 1418,
    bio: 'Sritharan Jayaraman is a technology and digital transformation leader with 28 years of experience in AI, cloud computing, and enterprise solutions. He helps organizations accelerate innovation, optimize operations, and drive sustainable business growth.',
    social: {
      linkedin: 'https://www.linkedin.com/in/sritharan-j-14510b51',
    },
  },
  {
    id: 4,
    name: 'Sanjai Subramanian',
    title: 'Head – Business Solutions & Technology',
    image: sanjaiImage,
    width: 1254,
    height: 1254,
    bio: 'Technology leader specializing in Artificial Intelligence, IoT, Robotics, Cloud Computing, and Software Development, committed to driving innovation and delivering intelligent solutions that accelerate business transformation.',
    social: {
      linkedin: 'https://www.linkedin.com/in/sanjai2609',
    },
  },
];

const TeamCardsGrid: React.FC = () => {
  const [expandedCard, setExpandedCard] = useState<number | null>(null);

  return (
    <>
      <div className="team-cards-grid">
        {teamMembers.map((member) => (
          <div key={member.id} className={`team-card ${expandedCard === member.id ? 'expanded' : ''}`}>
            <div className="team-card-image">
              <img loading="lazy" decoding="async" src={member.image} alt={member.name} width={member.width} height={member.height} title="Vivify Soft Tech" />
              <div className="team-card-overlay">
                <div className="team-card-info">
                  <h3 className="team-card-name">{member.name}</h3>
                  <p className="team-card-title">{member.title}</p>
                </div>
              </div>

              <div className="team-card-expanded-panel" aria-hidden={expandedCard !== member.id}>
                <div className="team-card-expanded-header">
                  <h3>{member.name}</h3>
                  <p>{member.title}</p>
                </div>
                <p className="team-card-expanded-bio">{member.bio}</p>
                <div className="team-card-expanded-socials">
                  {member.social.facebook && (
                    <a href={member.social.facebook} target="_blank" rel="noopener noreferrer" aria-label={`${member.name} Facebook`}>
                      <FacebookIcon />
                    </a>
                  )}
                  {member.social.linkedin && (
                    <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label={`${member.name} LinkedIn`} className="linkedin-icon">
                      <LinkedinIcon />
                    </a>
                  )}
                  {member.social.twitter && (
                    <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" aria-label={`${member.name} Twitter`}>
                      <TwitterIcon />
                    </a>
                  )}
                </div>
              </div>
            </div>
            <button
              className="team-card-expand-btn-floating"
              onClick={() => setExpandedCard(expandedCard === member.id ? null : member.id)}
              aria-label={`Toggle ${member.name} profile`}
            >
              <Plus size={24} />
            </button>
          </div>
        ))}
      </div>
    </>
  );
};

export default AboutPageContent;